import { render, staticRenderFns } from "./GlyphSortButtonGroup.vue?vue&type=template&id=8971b8fa&scoped=true&"
import script from "./GlyphSortButtonGroup.vue?vue&type=script&lang=js&"
export * from "./GlyphSortButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8971b8fa",
  null
  
)

export default component.exports